// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import Address from "./address.js"
import Contact from "./contact.js"
import Invoice from "./invoice.js"
import OrderDelivery from "./order-delivery.js"
import OrderGeneration from "./order-generation.js"
import OrderGenerationOrder from "./order-generation-order.js"
import OrderLine from "./order-line.js"
import Tenant from "./tenant.js"

const modelClassData = {
  "attributes": {
    "accept_of_privacy_policy": {
      "column": {
        "default": false,
        "name": "accept_of_privacy_policy",
        "null": false,
        "type": "boolean"
      },
      "name": "accept_of_privacy_policy",
      "selected_by_default": null,
      "translated": null
    },
    "accept_of_terms_and_conditions": {
      "column": {
        "default": false,
        "name": "accept_of_terms_and_conditions",
        "null": false,
        "type": "boolean"
      },
      "name": "accept_of_terms_and_conditions",
      "selected_by_default": null,
      "translated": null
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "customer_email": {
      "column": {
        "default": null,
        "name": "customer_email",
        "null": true,
        "type": "string"
      },
      "name": "customer_email",
      "selected_by_default": null,
      "translated": null
    },
    "customer_first_name": {
      "column": {
        "default": null,
        "name": "customer_first_name",
        "null": true,
        "type": "string"
      },
      "name": "customer_first_name",
      "selected_by_default": null,
      "translated": null
    },
    "customer_id": {
      "column": {
        "default": null,
        "name": "customer_id",
        "null": false,
        "type": "uuid"
      },
      "name": "customer_id",
      "selected_by_default": null,
      "translated": null
    },
    "customer_last_name": {
      "column": {
        "default": null,
        "name": "customer_last_name",
        "null": true,
        "type": "string"
      },
      "name": "customer_last_name",
      "selected_by_default": null,
      "translated": null
    },
    "customer_mobile_phone_number": {
      "column": {
        "default": null,
        "name": "customer_mobile_phone_number",
        "null": true,
        "type": "string"
      },
      "name": "customer_mobile_phone_number",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "invoice_address_id": {
      "column": {
        "default": null,
        "name": "invoice_address_id",
        "null": true,
        "type": "uuid"
      },
      "name": "invoice_address_id",
      "selected_by_default": null,
      "translated": null
    },
    "last_reminder_sent_at": {
      "column": {
        "default": null,
        "name": "last_reminder_sent_at",
        "null": true,
        "type": "datetime"
      },
      "name": "last_reminder_sent_at",
      "selected_by_default": null,
      "translated": null
    },
    "order_lines_count": {
      "column": {
        "default": 0,
        "name": "order_lines_count",
        "null": false,
        "type": "integer"
      },
      "name": "order_lines_count",
      "selected_by_default": null,
      "translated": null
    },
    "order_number": {
      "column": {
        "default": null,
        "name": "order_number",
        "null": false,
        "type": "string"
      },
      "name": "order_number",
      "selected_by_default": null,
      "translated": null
    },
    "ordered_at": {
      "column": {
        "default": null,
        "name": "ordered_at",
        "null": true,
        "type": "datetime"
      },
      "name": "ordered_at",
      "selected_by_default": null,
      "translated": null
    },
    "permitted_transitions": {
      "column": null,
      "name": "permitted_transitions",
      "selected_by_default": null,
      "translated": null
    },
    "price": {
      "column": null,
      "name": "price",
      "selected_by_default": null,
      "translated": null
    },
    "price_with_vat": {
      "column": null,
      "name": "price_with_vat",
      "selected_by_default": null,
      "translated": null
    },
    "process_contact_id": {
      "column": {
        "default": null,
        "name": "process_contact_id",
        "null": true,
        "type": "uuid"
      },
      "name": "process_contact_id",
      "selected_by_default": null,
      "translated": null
    },
    "requires_manual_action": {
      "column": {
        "default": false,
        "name": "requires_manual_action",
        "null": false,
        "type": "boolean"
      },
      "name": "requires_manual_action",
      "selected_by_default": null,
      "translated": null
    },
    "state": {
      "column": {
        "default": "basket",
        "name": "state",
        "null": false,
        "type": "string"
      },
      "name": "state",
      "selected_by_default": null,
      "translated": null
    },
    "translated_state": {
      "column": null,
      "name": "translated_state",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    },
    "any_digital_products": {
      "column": null,
      "name": "any_digital_products",
      "selected_by_default": false,
      "translated": null
    },
    "expected_delivery_at": {
      "column": null,
      "name": "expected_delivery_at",
      "selected_by_default": false,
      "translated": null
    },
    "packing_slip_pdf_path": {
      "column": null,
      "name": "packing_slip_pdf_path",
      "selected_by_default": false,
      "translated": null
    },
    "quantity_sum": {
      "column": null,
      "name": "quantity_sum",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "Order",
  "collectionKey": "orders",
  "collectionName": "orders",
  "i18nKey": "order",
  "camelizedLower": "order",
  "name": "Order",
  "nameDasherized": "order",
  "pluralName": "orders",
  "ransackable_associations": [
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "customer_id",
      "name": "customer",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "Invoice",
      "collectionName": "invoices",
      "foreignKey": "order_id",
      "name": "invoice",
      "macro": "has_one",
      "resource_name": "Invoice",
      "through": null
    },
    {
      "className": "Address",
      "collectionName": "addresses",
      "foreignKey": "invoice_address_id",
      "name": "invoice_address",
      "macro": "belongs_to",
      "resource_name": "Address",
      "through": null
    },
    {
      "className": "Invoice",
      "collectionName": "invoices",
      "foreignKey": "order_id",
      "name": "invoices",
      "macro": "has_many",
      "resource_name": "Invoice",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "OrderDelivery",
      "collectionName": "order_deliveries",
      "foreignKey": "order_id",
      "name": "order_delivery",
      "macro": "has_one",
      "resource_name": "OrderDelivery",
      "through": null
    },
    {
      "className": "OrderGenerationOrder",
      "collectionName": "order_generation_orders",
      "foreignKey": "order_id",
      "name": "order_generation_orders",
      "macro": "has_many",
      "resource_name": "OrderGenerationOrder",
      "through": null
    },
    {
      "className": "OrderGeneration",
      "collectionName": "order_generations",
      "foreignKey": "order_generation_id",
      "name": "order_generations",
      "macro": "has_many",
      "resource_name": "OrderGeneration",
      "through": "order_generation_orders"
    },
    {
      "className": "OrderLine",
      "collectionName": "order_lines",
      "foreignKey": "order_id",
      "name": "order_lines",
      "macro": "has_many",
      "resource_name": "OrderLine",
      "through": null
    },
    {
      "className": "ActiveStorage::Attachment",
      "collectionName": "active_storage_attachments",
      "foreignKey": "record_id",
      "name": "packing_slip_attachment",
      "macro": "has_one",
      "resource_name": "ActiveStorageAttachment",
      "through": null
    },
    {
      "className": "ActiveStorage::Blob",
      "collectionName": "active_storage_blobs",
      "foreignKey": "blob_id",
      "name": "packing_slip_blob",
      "macro": "has_one",
      "resource_name": "ActiveStorageBlob",
      "through": "packing_slip_attachment"
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "process_contact_id",
      "name": "process_contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "accept_of_privacy_policy",
      "column": {
        "default": false,
        "name": "accept_of_privacy_policy",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "accept_of_terms_and_conditions",
      "column": {
        "default": false,
        "name": "accept_of_terms_and_conditions",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "customer_email",
      "column": {
        "default": null,
        "name": "customer_email",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "customer_first_name",
      "column": {
        "default": null,
        "name": "customer_first_name",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "customer_id",
      "column": {
        "default": null,
        "name": "customer_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "customer_last_name",
      "column": {
        "default": null,
        "name": "customer_last_name",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "customer_mobile_phone_number",
      "column": {
        "default": null,
        "name": "customer_mobile_phone_number",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "invoice_address_id",
      "column": {
        "default": null,
        "name": "invoice_address_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "last_reminder_sent_at",
      "column": {
        "default": null,
        "name": "last_reminder_sent_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "order_line_number",
      "column": {
        "default": 0,
        "name": "order_line_number",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "order_lines_count",
      "column": {
        "default": 0,
        "name": "order_lines_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "order_number",
      "column": {
        "default": null,
        "name": "order_number",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "ordered_at",
      "column": {
        "default": null,
        "name": "ordered_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "price_cents",
      "column": {
        "default": 0,
        "name": "price_cents",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "price_currency",
      "column": {
        "default": "DKK",
        "name": "price_currency",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "price_with_vat_cents",
      "column": {
        "default": 0,
        "name": "price_with_vat_cents",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "price_with_vat_currency",
      "column": {
        "default": "DKK",
        "name": "price_with_vat_currency",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "process_contact_id",
      "column": {
        "default": null,
        "name": "process_contact_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "requires_manual_action",
      "column": {
        "default": false,
        "name": "requires_manual_action",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "state",
      "column": {
        "default": "basket",
        "name": "state",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "vat_cents",
      "column": {
        "default": 0,
        "name": "vat_cents",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "vat_currency",
      "column": {
        "default": "DKK",
        "name": "vat_currency",
        "null": false,
        "type": "string"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "customer_id",
      "name": "customer",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "Invoice",
      "collectionName": "invoices",
      "foreignKey": "order_id",
      "name": "invoice",
      "macro": "has_one",
      "resource_name": "Invoice",
      "through": null
    },
    {
      "className": "Address",
      "collectionName": "addresses",
      "foreignKey": "invoice_address_id",
      "name": "invoice_address",
      "macro": "belongs_to",
      "resource_name": "Address",
      "through": null
    },
    {
      "className": "OrderDelivery",
      "collectionName": "order_deliveries",
      "foreignKey": "order_id",
      "name": "order_delivery",
      "macro": "has_one",
      "resource_name": "OrderDelivery",
      "through": null
    },
    {
      "className": "OrderGeneration",
      "collectionName": "order_generations",
      "foreignKey": "order_generation_id",
      "name": "order_generations",
      "macro": "has_many",
      "resource_name": "OrderGeneration",
      "through": "order_generation_orders"
    },
    {
      "className": "OrderGenerationOrder",
      "collectionName": "order_generation_orders",
      "foreignKey": "order_id",
      "name": "order_generation_orders",
      "macro": "has_many",
      "resource_name": "OrderGenerationOrder",
      "through": null
    },
    {
      "className": "OrderLine",
      "collectionName": "order_lines",
      "foreignKey": "order_id",
      "name": "order_lines",
      "macro": "has_many",
      "resource_name": "OrderLine",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "process_contact_id",
      "name": "process_contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    }
  ],
  "paramKey": "order",
  "primaryKey": "id"
}

/** Frontend model for Order. */
export default class Order extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {boolean} */
  acceptOfPrivacyPolicy() {
    return this.readAttributeUnderscore("accept_of_privacy_policy")
  }

  /** @returns {boolean} */
  hasAcceptOfPrivacyPolicy() {
    const value = this.acceptOfPrivacyPolicy()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  acceptOfTermsAndConditions() {
    return this.readAttributeUnderscore("accept_of_terms_and_conditions")
  }

  /** @returns {boolean} */
  hasAcceptOfTermsAndConditions() {
    const value = this.acceptOfTermsAndConditions()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  customerEmail() {
    return this.readAttributeUnderscore("customer_email")
  }

  /** @returns {boolean} */
  hasCustomerEmail() {
    const value = this.customerEmail()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  customerFirstName() {
    return this.readAttributeUnderscore("customer_first_name")
  }

  /** @returns {boolean} */
  hasCustomerFirstName() {
    const value = this.customerFirstName()

    return this._isPresent(value)
  }

  /** @returns {string} */
  customerId() {
    return this.readAttributeUnderscore("customer_id")
  }

  /** @returns {boolean} */
  hasCustomerId() {
    const value = this.customerId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  customerLastName() {
    return this.readAttributeUnderscore("customer_last_name")
  }

  /** @returns {boolean} */
  hasCustomerLastName() {
    const value = this.customerLastName()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  customerMobilePhoneNumber() {
    return this.readAttributeUnderscore("customer_mobile_phone_number")
  }

  /** @returns {boolean} */
  hasCustomerMobilePhoneNumber() {
    const value = this.customerMobilePhoneNumber()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  invoiceAddressId() {
    return this.readAttributeUnderscore("invoice_address_id")
  }

  /** @returns {boolean} */
  hasInvoiceAddressId() {
    const value = this.invoiceAddressId()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  lastReminderSentAt() {
    return this.readAttributeUnderscore("last_reminder_sent_at")
  }

  /** @returns {boolean} */
  hasLastReminderSentAt() {
    const value = this.lastReminderSentAt()

    return this._isPresent(value)
  }

  /** @returns {number} */
  orderLinesCount() {
    return this.readAttributeUnderscore("order_lines_count")
  }

  /** @returns {boolean} */
  hasOrderLinesCount() {
    const value = this.orderLinesCount()

    return this._isPresent(value)
  }

  /** @returns {string} */
  orderNumber() {
    return this.readAttributeUnderscore("order_number")
  }

  /** @returns {boolean} */
  hasOrderNumber() {
    const value = this.orderNumber()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  orderedAt() {
    return this.readAttributeUnderscore("ordered_at")
  }

  /** @returns {boolean} */
  hasOrderedAt() {
    const value = this.orderedAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  permittedTransitions() {
    return this.readAttributeUnderscore("permitted_transitions")
  }

  /** @returns {boolean} */
  hasPermittedTransitions() {
    const value = this.permittedTransitions()

    return this._isPresent(value)
  }

  /** @returns {any} */
  price() {
    return this.readAttributeUnderscore("price")
  }

  /** @returns {boolean} */
  hasPrice() {
    const value = this.price()

    return this._isPresent(value)
  }

  /** @returns {any} */
  priceWithVat() {
    return this.readAttributeUnderscore("price_with_vat")
  }

  /** @returns {boolean} */
  hasPriceWithVat() {
    const value = this.priceWithVat()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  processContactId() {
    return this.readAttributeUnderscore("process_contact_id")
  }

  /** @returns {boolean} */
  hasProcessContactId() {
    const value = this.processContactId()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  requiresManualAction() {
    return this.readAttributeUnderscore("requires_manual_action")
  }

  /** @returns {boolean} */
  hasRequiresManualAction() {
    const value = this.requiresManualAction()

    return this._isPresent(value)
  }

  /** @returns {string} */
  state() {
    return this.readAttributeUnderscore("state")
  }

  /** @returns {boolean} */
  hasState() {
    const value = this.state()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedState() {
    return this.readAttributeUnderscore("translated_state")
  }

  /** @returns {boolean} */
  hasTranslatedState() {
    const value = this.translatedState()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  anyDigitalProducts() {
    return this.readAttributeUnderscore("any_digital_products")
  }

  /** @returns {boolean} */
  hasAnyDigitalProducts() {
    const value = this.anyDigitalProducts()

    return this._isPresent(value)
  }

  /** @returns {any} */
  expectedDeliveryAt() {
    return this.readAttributeUnderscore("expected_delivery_at")
  }

  /** @returns {boolean} */
  hasExpectedDeliveryAt() {
    const value = this.expectedDeliveryAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  packingSlipPdfPath() {
    return this.readAttributeUnderscore("packing_slip_pdf_path")
  }

  /** @returns {boolean} */
  hasPackingSlipPdfPath() {
    const value = this.packingSlipPdfPath()

    return this._isPresent(value)
  }

  /** @returns {any} */
  quantitySum() {
    return this.readAttributeUnderscore("quantity_sum")
  }

  /** @returns {boolean} */
  hasQuantitySum() {
    const value = this.quantitySum()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static addPhotoToBasket(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "add_photo_to_basket",
        collectionName: "orders",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static createShipmentsForOrdersInWorkplace(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "create_shipments_for_orders_in_workplace",
        collectionName: "orders",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static generateFile(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "generate_file",
        collectionName: "orders",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static generateFileForOrdersInWorkplace(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "generate_file_for_orders_in_workplace",
        collectionName: "orders",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static generatePackingSlipsForOrdersInWorkplace(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "generate_packing_slips_for_orders_in_workplace",
        collectionName: "orders",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static printShipmentLabelsForOrdersInWorkplace(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "print_shipment_labels_for_orders_in_workplace",
        collectionName: "orders",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static statistics(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "statistics",
        collectionName: "orders",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static statisticsCsv(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "statistics_csv",
        collectionName: "orders",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  cancel(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "cancel",
        primaryKey: this.primaryKey(),
        collectionName: "orders",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  deliveryMethods(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "delivery_methods",
        primaryKey: this.primaryKey(),
        collectionName: "orders",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  finishProcess(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "finish_process",
        primaryKey: this.primaryKey(),
        collectionName: "orders",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  process(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "process",
        primaryKey: this.primaryKey(),
        collectionName: "orders",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  updateRequiresManualAction(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "update_requires_manual_action",
        primaryKey: this.primaryKey(),
        collectionName: "orders",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  reset(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "reset",
        primaryKey: this.primaryKey(),
        collectionName: "orders",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  shipmondoTemplates(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "shipmondo_templates",
        primaryKey: this.primaryKey(),
        collectionName: "orders",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  updateAcceptedTerms(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "update_accepted_terms",
        primaryKey: this.primaryKey(),
        collectionName: "orders",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  updateCustomerInformation(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "update_customer_information",
        primaryKey: this.primaryKey(),
        collectionName: "orders",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  updateDelivery(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "update_delivery",
        primaryKey: this.primaryKey(),
        collectionName: "orders",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  validForPayment(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "valid_for_payment",
        primaryKey: this.primaryKey(),
        collectionName: "orders",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("./contact.js").default | null} */
  customer() {
    return this._readBelongsToReflection({modelClass: Contact, reflectionName: "customer"})
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  loadCustomer() {
    if (!("customerId" in this)) throw new Error("Foreign key method wasn't defined: customerId")

    const id = this.customerId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "customer",
        model: this,
        modelClass: Contact
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  ensureCustomerLoaded() {
    return this.ensureAssociationLoaded("customer")
  }

  /** @returns {import("./invoice.js").default | null} */
  invoice() {
    return this._readHasOneReflection({modelClass: Invoice, reflectionName: "invoice"})
  }

  /** @returns {Promise<import("./invoice.js").default | null>} */
  loadInvoice() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["order_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "invoice",
        model: this,
        modelClass: Invoice
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./invoice.js").default | null>} */
  ensureInvoiceLoaded() {
    return this.ensureAssociationLoaded("invoice")
  }

  /** @returns {import("./address.js").default | null} */
  invoiceAddress() {
    return this._readBelongsToReflection({modelClass: Address, reflectionName: "invoice_address"})
  }

  /** @returns {Promise<import("./address.js").default | null>} */
  loadInvoiceAddress() {
    if (!("invoiceAddressId" in this)) throw new Error("Foreign key method wasn't defined: invoiceAddressId")

    const id = this.invoiceAddressId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "invoice_address",
        model: this,
        modelClass: Address
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./address.js").default | null>} */
  ensureInvoiceAddressLoaded() {
    return this.ensureAssociationLoaded("invoice_address")
  }

  /** @returns {import("./order-delivery.js").default | null} */
  orderDelivery() {
    return this._readHasOneReflection({modelClass: OrderDelivery, reflectionName: "order_delivery"})
  }

  /** @returns {Promise<import("./order-delivery.js").default | null>} */
  loadOrderDelivery() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["order_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "order_delivery",
        model: this,
        modelClass: OrderDelivery
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./order-delivery.js").default | null>} */
  ensureOrderDeliveryLoaded() {
    return this.ensureAssociationLoaded("order_delivery")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./order-generation.js").default>} */
  orderGenerations() {
    return new Collection(
      {
        reflectionName: "order_generations",
        model: this,
        modelClass: OrderGeneration
      },
      {
        params: {
          through: {
            model: "Order",
            id: this.primaryKey(),
            reflection: "order_generations"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./order-generation.js").default>>} */
  loadOrderGenerations() {
    return this._loadHasManyReflection(
      {
        reflectionName: "order_generations",
        model: this,
        modelClass: OrderGeneration
      },
      {
        params: {
          through: {
            model: "Order",
            id: this.primaryKey(),
            reflection: "order_generations"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./order-generation.js").default>>} */
  ensureOrderGenerationsLoaded() {
    return this.ensureAssociationLoaded("order_generations")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./order-generation-order.js").default>} */
  orderGenerationOrders() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["order_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "order_generation_orders",
        model: this,
        modelClass: OrderGenerationOrder
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./order-generation-order.js").default>>} */
  loadOrderGenerationOrders() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["order_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "order_generation_orders",
        model: this,
        modelClass: OrderGenerationOrder
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./order-generation-order.js").default>>} */
  ensureOrderGenerationOrdersLoaded() {
    return this.ensureAssociationLoaded("order_generation_orders")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./order-line.js").default>} */
  orderLines() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["order_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "order_lines",
        model: this,
        modelClass: OrderLine
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./order-line.js").default>>} */
  loadOrderLines() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["order_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "order_lines",
        model: this,
        modelClass: OrderLine
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./order-line.js").default>>} */
  ensureOrderLinesLoaded() {
    return this.ensureAssociationLoaded("order_lines")
  }

  /** @returns {import("./contact.js").default | null} */
  processContact() {
    return this._readBelongsToReflection({modelClass: Contact, reflectionName: "process_contact"})
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  loadProcessContact() {
    if (!("processContactId" in this)) throw new Error("Foreign key method wasn't defined: processContactId")

    const id = this.processContactId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "process_contact",
        model: this,
        modelClass: Contact
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  ensureProcessContactLoaded() {
    return this.ensureAssociationLoaded("process_contact")
  }

  /** @returns {import("./tenant.js").default | null} */
  tenant() {
    return this._readBelongsToReflection({modelClass: Tenant, reflectionName: "tenant"})
  }

  /** @returns {Promise<import("./tenant.js").default | null>} */
  loadTenant() {
    if (!("tenantId" in this)) throw new Error("Foreign key method wasn't defined: tenantId")

    const id = this.tenantId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "tenant",
        model: this,
        modelClass: Tenant
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./tenant.js").default | null>} */
  ensureTenantLoaded() {
    return this.ensureAssociationLoaded("tenant")
  }
}
